import {
  FormattedNamesDTO,
} from '@/dtos';
import {
  notEmptyString,
} from '@/utils/misc';
import {
  displayNameKey,
  initialsKey,
} from '@/types/nameFormat';

export function getDisplayName(
  formattedNames?: FormattedNamesDTO | null,
  fallback = '',
): string {
  const displayName = formattedNames?.[displayNameKey] ?? fallback;
  return notEmptyString(displayName) ? displayName : fallback;
}

export function getInitials(
  formattedNames?: FormattedNamesDTO | null,
): string | null | undefined {
  return formattedNames?.[initialsKey];
}
